import { NextApiResponseBody } from 'types/bolt-api/request'
import { ItsmeState } from './types'
import { Language } from 'types/language'

/**
  GET requests to redirect to the itsme authorization URL
  @param {ItsmeState} state - The URL parameters to include in the request
  @param {Language} language - To determine the correct redirect_uri
  @returns The response body containing the authorization URL or undefined in case of an error
 */
const authorize = async (state: ItsmeState, language: Language): Promise<NextApiResponseBody<{ url: string }>> => {
  try {
    const response = await fetch(`/api/itsme/authorize?state=${JSON.stringify(state)}&language=${language}`, { method: 'GET' })
    return await response.json()
  } catch (_) {
    return undefined
  }
}

export default authorize
